import store from '@/store';
import ApiService from '@/services/ApiService';
import ApiEndpoints from '@/config/ApiEndpoints';

export default class Logout {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService

    /**
     * Logout constructor.
     *
     * @returns {void}
     */
    constructor() {
        this.apiService = new ApiService(process.env.VUE_APP_API_URL);

        this.apiService.enableAuth();
    }

    /**
     * Logs the user out in the backend.
     *
     * @returns {Promise}
     */
    handle() {
        return this.apiService.post(ApiEndpoints['auth.logout']);
    }

    /**
     * Logs the user out in the frontend.
     *
     * @returns {void}
     */
    frontendLogout() {
        store.dispatch('auth/logout');
    }
}
